import { render } from "./PayFileCollectionEditModal.vue?vue&type=template&id=4e70ceec&scoped=true"
import script from "./PayFileCollectionEditModal.vue?vue&type=script&lang=js"
export * from "./PayFileCollectionEditModal.vue?vue&type=script&lang=js"

import "./PayFileCollectionEditModal.vue?vue&type=style&index=0&id=4e70ceec&scoped=true&lang=less"
import "./PayFileCollectionEditModal.vue?vue&type=style&index=1&id=4e70ceec&lang=less"

import exportComponent from "D:\\work\\sckj\\tipian\\vue\\tipian_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e70ceec"]])

export default __exports__